import React, { Suspense } from 'react';
import { HStack } from '@chakra-ui/react';
import ModalCheatSheet from '../ModalCheatSheet';
import HistoryDrawer from '../HistoryDrawer';
import { TourTrigger } from '../ui/coachmarks/TourTrigger';
import { IUpdatedQuery } from '../../context/queryBuilderProvider';
import { IJsonQuery } from '../HistoryDrawer';

interface AppNavigationProps {
  displayUserName: string | null;
  userName: string;
  updateFunction: (query: IUpdatedQuery | IJsonQuery) => string;
}

const AppNavigation: React.FC<AppNavigationProps> = ({
  displayUserName,
  userName,
  updateFunction,
}) => {
  return (
    <HStack align="center" gap={[1, 2]}>
      <ModalCheatSheet />

      {/* Tour Guide Button */}
      <TourTrigger tourId="first-query-tour" variant="outline" size="sm">
        🎯 Quick Start Guide
      </TourTrigger>

      {displayUserName && displayUserName !== 'Log In' && (
        <Suspense fallback={<div>Loading history...</div>}>
          <HistoryDrawer updateFunction={updateFunction} userName={userName} />
        </Suspense>
      )}
    </HStack>
  );
};

export default AppNavigation;
